import React, {Component, useRef} from 'react';
import {HashRouter as Router, Switch, Route, Link} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Toast} from 'primereact/toast';
import {Menubar} from 'primereact/menubar';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import Favicon from 'react-favicon';
import {Sidebar} from "primereact/sidebar";
import {BlockUI} from "primereact/blockui";
import {Dialog} from "primereact/dialog";
import currencyFormatter from "currency-formatter";
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-purple/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.scss';
import './assets/css/app.css';
import {Panel} from "primereact/panel";
import axios from 'axios';
import { VERSION as CURRENT_VERSION } from './version';


import LoginPage from './pages/2.0/LoginPage';
import PasswordResetPage from "./pages/2.0/PasswordResetPage";
import PasswordSetPage from "./pages/2.0/PasswordSetPage";
import DashboardPage from './pages/2.0/DashboardPage';
import SubscriptionPage from './pages/2.0/SubscriptionPage';
import TracklogDashboardPage from './pages/2.0/tracklog/TracklogDashboardPage';
import ProjectDashboardPage from "./pages/2.0/project/ProjectDashboardPage";
import FinanceDashboardPage from "./pages/2.0/finance/FinanceDashboardPage";
import FinancePage from './pages/2.1/FinancePage';
import PurchaseDashboardPage from "./pages/2.0/purchase/PurchaseDashboardPage";
import OrderDashboardPage from "./pages/2.0/order/OrderDashboardPage";
// import SettingsDashboardPage from "./pages/2.0/settings/SettingsDashboardPage";
import ProfileFormComponent from "./components/2.0/profile/ProfileFormComponent";
import ProductionDashboardPage from "./pages/2.0/production/ProductionDashboardPage";
import RegisterPage from "./pages/2.1/RegisterPage";
import RegistrationOnboardingPage from "./pages/2.1/RegistrationOnboardingPage";
import PartnerPage from "./pages/2.1/PartnerPage";
import CrmPage from "./pages/2.1/CrmPage";
import ProjectPage from "./pages/2.1/ProjectPage";
import ProductionPage from "./pages/2.1/ProductionPage";
import HrPage from "./pages/2.1/HrPage";
import DocsPage from "./pages/2.1/DocsPage";
import InventoryPage from "./pages/2.1/InventoryPage";
import ProcurementPage from "./pages/2.1/ProcurementPage";
import SettingsPage from "./pages/2.1/SettingsPage";
import RecruitmentPage from './pages/2.1/RecruitmentPage';
import NewPasswordPage from "./pages/2.1/NewPasswordPage";
import _TMPPage from "./pages/2.1/_TMPPage";

import UserLogoutService from './components/2.0/_services/user/UserLogoutService';
import NetworkListService from "./components/2.0/_services/network/NetworkListService";
import ModulesListService from "./components/2.0/_services/modules/ModulesListService";
import NetworkSubscriptionMessageService from "./components/2.0/_services/network/NetworkSubscriptionMessageService";
import SystemSettingsFormComponent from './components/2.1/settings/systemsettings/SystemSettingsFormComponent';

import i18next from 'i18next';
import common_hu from "./translations/hu/common.json";
import common_en from "./translations/en/common-en.json";
import common_de from "./translations/de/common-de.json";
import common_hu_brw from "./translations/hu/common_brw.json";
import common_hu_water2farm from "./translations/hu/common_water2farm.json";
import common_hu_lbuild from "./translations/hu/common_lbuild.json";
import {SplitButton} from "primereact/splitbutton";
import {Slider} from "primereact/slider";
import ProjectListComponent from './components/2.1/project/ProjectListComponent';
import HelperComponent from './components/2.1/helper/HelperComponent';
import { HelperProvider } from './components/2.1/helper/HelperService';
import HelperPage from './pages/2.1/HelperPage';

const LANGUAGE_OPTIONS = [
  {label: 'Magyar', value: 'hu'},
  {label: 'English', value: 'en'},
  {label: 'Deutsch', value: 'de'},
];
const SUPPORTED_LANGUAGE_CODES = LANGUAGE_OPTIONS.map(option => option.value);

const normalizeLanguage = (language) => {
  const normalized = (language || '').toString().toLowerCase().split('-')[0];
  return SUPPORTED_LANGUAGE_CODES.includes(normalized) ? normalized : null;
};

const CUSTOMER_BRANDS = ['brw', 'lbuild', 'water2farm', 'szermann', 'opuseu', 't2d', 'sdm', 'sidronautika'];
const isCustomerBrandInstance = () => CUSTOMER_BRANDS.includes((process.env.REACT_APP_BRAND || '').toString().toLowerCase());
const getFixedLanguage = () => isCustomerBrandInstance() ? 'hu' : normalizeLanguage(process.env.REACT_APP_LANGUAGE);
const isLanguageSelectorEnabled = () => !isCustomerBrandInstance() && !getFixedLanguage();

const getInitialLanguage = () => (
  getFixedLanguage() ||
  normalizeLanguage(localStorage.getItem('trackieLanguage')) ||
  normalizeLanguage(localStorage.getItem('user.locale')) ||
  normalizeLanguage(localStorage.getItem('userLocale')) ||
  normalizeLanguage(process.env.REACT_APP_DEFAULT_LANGUAGE) ||
  'hu'
);

const commonResources = (huOverrides = {}) => ({
  hu: {
    common: {
      ...common_hu,
      ...huOverrides
    }
  },
  en: {
    common: common_en
  },
  de: {
    common: common_de
  }
});

if (process.env.REACT_APP_BRAND === 'lbuild') {
  require('./assets/css/lbuild.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'brw') {
  require('./assets/css/brw.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'szermann') {
  require('./assets/css/szermann.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'opuseu') {
  require('./assets/css/opuseu.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 't2d') {
  require('./assets/css/t2d.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'water2farm') {
  require('./assets/css/water2farm.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'sdm') {
  require('./assets/css/sdm.css');
  require('primereact/resources/themes/saga-blue/theme.css');
}
if (process.env.REACT_APP_BRAND === 'sidronautika') {
  require('./assets/css/sidronautika.css');
  require('primereact/resources/themes/saga-orange/theme.css');
}

class App extends Component {

  constructor(props) {
    super(props);
    this.logoutTimeoutId = null;
    this.logoutIntervalId = null;
    this.toastShow = this.toastShow.bind(this);
    this.changeAppLanguage = this.changeAppLanguage.bind(this);

    window.App = this;
    const language = getInitialLanguage();

    this.state = {
      subscriptionModel: [],
      currentLocation: window.location.href,
      receiptGroups: [],
      projectTypes: [],
      newVersionAvailable: false,
      language,
      // sessionRemainingSeconds: null,
    }

    this.menu = [];
    if (process.env.REACT_APP_BRAND === 'lbuild') {
      i18next.init({
        resources: commonResources(common_hu_lbuild),
        lng: language,
        fallbackLng: 'hu',
        interpolation: { escapeValue: false },
      });
    } else if (process.env.REACT_APP_BRAND === 'brw') {
      i18next.init({
        resources: commonResources(common_hu_brw),
        lng: language,
        fallbackLng: 'hu',
        interpolation: { escapeValue: false },
      });
    } else if (process.env.REACT_APP_BRAND === 'water2farm') {
      i18next.init({
        resources: commonResources(common_hu_water2farm),
        lng: language,
        fallbackLng: 'hu',
        interpolation: { escapeValue: false },
      });
    } else {
      i18next.init({
        resources: commonResources(),
        lng: language,
        fallbackLng: 'hu',
        interpolation: { escapeValue: false },
      });
    }
  };

  changeAppLanguage(language) {
    const normalizedLanguage = normalizeLanguage(language);
    if (!normalizedLanguage || !isLanguageSelectorEnabled()) {
      return;
    }

    localStorage.setItem('trackieLanguage', normalizedLanguage);
    localStorage.setItem('user.locale', normalizedLanguage);
    localStorage.setItem('userLocale', normalizedLanguage);
    i18next.changeLanguage(normalizedLanguage);
    this.setState({language: normalizedLanguage});
  }

  forceSessionExpiredLogout = () => {
    window.__sessionExpiredLogout = true;
    if (this.logoutTimeoutId) {
      clearTimeout(this.logoutTimeoutId);
      this.logoutTimeoutId = null;
    }
    if (this.logoutIntervalId) {
      clearInterval(this.logoutIntervalId);
      this.logoutIntervalId = null;
    }
    if (!localStorage.getItem('userToken')) {
      return;
    }
    UserLogoutService();
    this.toastShow(
      'warn',
      'A munkamenet lejárt',
      'A rendszer automatikusan kiléptetett.',
      5000
    );
  }

  checkVersion = () => {
  if (!localStorage.getItem('userToken')) return;
  fetch('/version.json?t=' + Date.now(), { cache: 'no-store' })
    .then(r => r.json())
    .then(data => {
      if (data.version && data.version !== CURRENT_VERSION) {
        this.setState({ newVersionAvailable: true });
      }
    })
    .catch(e => console.log("Verzió ellenőrzés hiba", e));
  }

  checkTokenAndLogoutIfExpired = () => {
    const token = localStorage.getItem('userToken');
    const labelEl = document.getElementById('sessionCountdownLabel');
    if (!token) {
      if (labelEl) {
        labelEl.textContent = '';
      }
      return;
    }
    let remainingSec = null;
    try {
      const parts = token.split('.');
      if (parts.length === 3) {
        let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4 !== 0) {
          base64 += '=';
        }
        const payloadJson = atob(base64);
        const payload = JSON.parse(payloadJson);
        if (payload.exp) {
          const expMs = payload.exp * 1000;
          const nowMs = Date.now();
          remainingSec = Math.max(0, Math.floor((expMs - nowMs) / 1000));
        }
      }
      if (remainingSec === null) {
        if (labelEl) {
          labelEl.textContent = '';
        }
        return;
      }
      if (labelEl) {
        if (remainingSec > 0) {
          const minutes = Math.floor(remainingSec / 60);
          const seconds = remainingSec % 60;
          const mm = minutes.toString();
          const ss = seconds.toString().padStart(2, '0');
          labelEl.textContent = `Kijelentkezés ${mm}:${ss} perc múlva.`;
        } else {
          labelEl.textContent = '';
        }
      }
      if (remainingSec <= 0) {
        if (this.logoutTimeoutId) {
          clearTimeout(this.logoutTimeoutId);
          this.logoutTimeoutId = null;
        }
        this.forceSessionExpiredLogout();
      }
    } catch (e) {
      console.error('JWT decode error a session timerben', e);
      if (labelEl) {
        labelEl.textContent = '';
      }
    }
  };

  loadReceiptGroups = () => {
    if (localStorage.getItem('userToken')) {
      axios.get(process.env.REACT_APP_API_HOST + '/api/v2/receipt-group', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'App-Network': localStorage.getItem('networkId') || ''
        }
      })
      .then((response) => {
        const data = response?.data?.data || response?.data;
        const items = data?.items || data || [];
        this.setState({ receiptGroups: items });
      })
      .catch((error) => {
        console.error('receipt-group list hiba:', error);
      });
    }
  }

  loadProjectTypes = () => {
    if (localStorage.getItem('userToken') && localStorage.getItem('networkId')) {
      axios.get(process.env.REACT_APP_API_HOST + '/api/v2/project-type', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'App-Network': localStorage.getItem('networkId') || ''
        }
      })
      .then((response) => {
        const data = response?.data?.data || response?.data;
        const items = data?.items || data || [];
        this.setState({
          projectTypes: items.filter(item => item.active === true)
        }, () => {
          this.forceUpdate();
        });
      })
      .catch((error) => {
        console.error('project-type list hiba:', error);
      });
    }
  }

  handleLocationChange = () => {
    this.setState({
      currentLocation: window.location.href
    });
    setTimeout(() => {
      this.markActiveMenuItem();
    }, 0);
  }

  //show active tabmenu
  markActiveMenuItem = () => {
    const hash = window.location.hash || '';
    const isMatch = (currentHash, targetHash) => {
      if (!targetHash) return false;
      if (currentHash === targetHash) return true;
      return (
        currentHash.startsWith(targetHash + '/') ||
        currentHash.startsWith(targetHash + '?')
      );
    };
    const allLinks = Array.from(document.querySelectorAll('.p-menubar a.p-menuitem-link'));
    allLinks.forEach(a => a.classList.remove('active-submenu-item'));
    const submenuLinks = allLinks.filter(a => a.closest('.p-submenu-list'));
    let best = null;
    let bestLen = -1;
    submenuLinks.forEach(a => {
      const href = (a.getAttribute('href') || '').replace('/#', '#');
      if (isMatch(hash, href) && href.length > bestLen) {
        best = a;
        bestLen = href.length;
      }
    });
    if (best) best.classList.add('active-submenu-item');
  };

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleLocationChange);
    if (this.versionCheckInterval) clearInterval(this.versionCheckInterval);
    if (this.logoutTimeoutId) {
      clearTimeout(this.logoutTimeoutId);
      this.logoutTimeoutId = null;
    }
    if (this.logoutIntervalId) {
      clearInterval(this.logoutIntervalId);
      this.logoutIntervalId = null;
    }
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.handleLocationChange);
    if (window.matchMedia("(prefers-color-scheme:dark)").matches === true) {
      document.getElementById('body').classList.add('dark-theme')
      document.getElementById('body').classList.add(process.env.REACT_APP_BRAND)
    }
    this.networkSelect();
    this.loadReceiptGroups();
    this.loadProjectTypes();
    localStorage.setItem('api_host', process.env.REACT_APP_API_HOST)
    if (localStorage.getItem('userToken')) {
      this.checkVersion();
      this.versionCheckInterval = setInterval(this.checkVersion, 60000);
      axios.get(process.env.REACT_APP_API_HOST + '/api/v2/profile', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'App-Network': localStorage.getItem('networkId') || ''
        }
      })
        .then((response) => {
          const employeeId = response?.data?.employee?.id;
          if (employeeId) {
            localStorage.setItem('employeeId', employeeId);
          }
          if (response?.data?.employeeName) {
            localStorage.setItem('employeeName', response.data.employeeName);
          }
        })
        .catch((error) => {
          console.error('my-profile error:', error);
        });
      axios.get(process.env.REACT_APP_API_HOST + '/api/v2/receipt-group', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'App-Network': localStorage.getItem('networkId') || ''
        }
      })
        .then((response) => {
          const data = response?.data?.data || response?.data;
          const items = data?.items || data || [];
          this.setState({ receiptGroups: items });
        })
        .catch((error) => {
          console.error('receipt-group list hiba:', error);
        });
      this.loadProjectTypes();
    }
    setTimeout(function () {
      document.getElementById('root').style.display = "block"
    }, 500)
    setInterval(function () {
      if (localStorage.getItem('userToken') && process.env.REACT_APP_SUBSCRIPTION_MESSAGES === "enabled") {
        NetworkSubscriptionMessageService()
          .then(response => {
            window.App.setState({
              subscriptionMessages: response.data
            })
          })
          .catch(error => {
            // window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          })
      }
    }, Number(process.env.REACT_APP_SUBSCRIPTION_GET_INTERVAL));
    if (process.env.REACT_APP_SUBSCRIPTIONS === "disabled") {
      this.setState({
        subscriptionModel: [
          {
            separator: false,
            template: () => <div className="p-py-2 p-px-3">
              <span className={"p-d-block"}>
                {localStorage.getItem('networkName')}
              </span>
            </div>
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div>
          },
        ]
      })
    } else {
      this.setState({
        subscriptionModel: [
          {
            separator: false,
            template: () => <div className="p-py-2 p-px-3">
                                            <span className={"p-d-block p-text-uppercase p-text-muted"}>
                                              <small style={{opacity: 0.5}}>ELŐFIZETŐI FIÓK</small>
                                            </span>
              <span className={"p-d-block p-mt-3"}>
                                              {localStorage.getItem('networkName')}
                                            </span>
            </div>
          },
          {
            label: 'Fiók adatok',
            icon: 'pi pi-building',
            command(e) {
              window.location.replace('/#/subscriptions');
              window.App.forceUpdate()
            },
            className: ''
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div>
          },
        ]
      })
    }
    this.attachAxiosInterceptors();
    this.setupAutoLogout();
    this.handleLocationChange();
  }

  componentDidUpdate(prevProps, prevState) {
    // if (!localStorage.getItem('scale')) {
    //   localStorage.setItem('scale', 'small')
    //   document.getElementById('app').classList.add('scale-small')
    // }
    if (localStorage.getItem('userToken') && !this.logoutIntervalId) {
      this.setupAutoLogout();
    }
    if (localStorage.getItem('scale') === 'small') {
      document.getElementById('app').classList.add('scale-small')
    }
    this.buildMenu();
    if (prevState.currentLocation !== this.state.currentLocation) {
      this.forceUpdate();
    }
    setTimeout(() => this.markActiveMenuItem(), 0);
  }

  translateDynamicMenuLabel = (prefix, value) => {
    if (!value) {
      return '';
    }
    return this.props.t(`${prefix}\\${value}`, {defaultValue: value});
  }

  buildMenu = () => {
    const currentHref = this.state.currentLocation || window.location.href;
    this.menu = []
    if (localStorage.getItem('module_partner') && JSON.parse(localStorage.getItem('roles') || '[]').includes('role_partner_read')) {
      this.menu.push(
        {
          label: this.props.t('App\\Partner\\Menu'),
          icon: 'pi pi-fw pi-briefcase',
          className: currentHref.includes('/#/partner') ? 'active-menu-item partner' : 'partner',
          items: this.cleanMenuItems([
            {
              label: this.props.t('App\\Partner'),
              icon: 'pi pi-list',
              url: '/#/partner',
            },
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div>
            },
            {
              label: this.props.t('App\\Partner\\Customer'),
              icon: 'pi pi-list',
              url: '/#/partner?view=customer',
            },
            {
              label: this.props.t('App\\Partner\\Vendor-service'),
              icon: 'pi pi-list',
              url: '/#/partner?view=vendor_service',
            },
            {
              label: this.props.t('App\\Partner\\Vendor-material'),
              icon: 'pi pi-list',
              url: '/#/partner?view=vendor_material',
            },
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div>
            },
            {
              label: this.props.t('App\\Partner\\Contact'),
              icon: 'pi pi-users',
              url: '/#/partner/contact',
            },
          ])
        }
      )
    }

    const normalizedRoles = ((localStorage.getItem('roles') || '') + '').toUpperCase();
    const materialMaster = normalizedRoles.includes('ROLE_MATERIAL_READ') ||
      ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_WRITE');
    const materialTrading = ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_TRADING_READ') || 
      ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_TRADING_WRITE');
    const materialProduction = ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_PRODUCTION_READ') || 
      ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_PRODUCTION_TG_WRITE');
    const materialOperations = ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_OPERATIONS_READ') || 
      ((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_OPERATIONS_WRITE');
    const materialSupplierPriceRead = ['ROLE_MATERIAL_PRODUCTION_READ', 'ROLE_MATERIAL_READ', 'ROLE_MATERIAL_TRADING_READ', 'ROLE_MATERIAL_OPERATIONS_READ']
      .some(role => normalizedRoles.includes(role));

    if (localStorage.getItem('module_crm')) {
      const crmMenu = 
        {
          label: this.props.t('App\\Crm\\Menu'),
          icon: 'pi pi-fw pi-users',
          className: currentHref.includes('/#/crm') ? 'active-menu-item hr' : 'hr',
          items: this.cleanMenuItems([
            {
              label: this.props.t('App\\Crm\\Dashboard'),
              icon: 'pi pi-chart-bar',
              url: '/#/crm',
            },
            // {
            //   label: 'Partnerek',
            //   icon: 'pi pi-users',
            //   url: '/#/crm/partner',
            // },
            (normalizedRoles.includes('ROLE_CRM_LEAD_READ') || normalizedRoles.includes('ROLE_CRM_LEAD_ROLE')) ?
            {
              label: this.props.t('App\\Crm\\Lead'),
              icon: 'pi pi-list',
              url: '/#/crm/lead',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_deal_read') ?
            {
              label: this.props.t('crmOpportunities'),
              icon: 'pi pi-briefcase',
              url: '/#/crm/deal',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_task_read') ?
            {
              label: this.props.t('App\\Crm\\Task'),
              icon: 'pi pi-check-square',
              url: '/#/crm/task',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_action_read') ?
            {
              label: this.props.t('App\\Crm\\Action'),
              icon: 'pi pi-history',
              url: '/#/crm/action',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') ?
            {
              label: this.props.t('newsletterCampaigns'),
              icon: 'pi pi-send',
              url: '/#/crm/campaign',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') ?
            {
              label: this.props.t('newsletterConnections'),
              icon: 'pi pi-link',
              url: '/#/crm/newsletter-connection',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') ?
            {
              label: this.props.t('crmSegments'),
              icon: 'pi pi-filter',
              url: '/#/crm/segment',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_campaign_read') ?
            {
              label: this.props.t('crmAudienceSettings'),
              icon: 'pi pi-sliders-h',
              url: '/#/crm/audience-settings',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_deal_read') ?
            {
              label: this.props.t('crmPipelines'),
              icon: 'pi pi-sitemap',
              url: '/#/crm/pipeline',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_task_read') ?
            {
              label: this.props.t('crmTaskStatuses'),
              icon: 'pi pi-tags',
              url: '/#/crm/task-status',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_crm_import_read') ?
            {
              label: this.props.t('partnerExternalImport'),
              icon: 'pi pi-upload',
              url: '/#/crm/import',
            }: null,
          ]).filter(Boolean)
        };
        if (crmMenu.items.some(item => !item.separator)) {
          this.menu.push(crmMenu);
        }
    }
    if (localStorage.getItem('module_project')) {
      let _dashboard = []
      if (localStorage.getItem('module_project_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Project\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/project/dashboard?summaryId=' + localStorage.getItem('module_project_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const projectTypeMenuItems = (this.state.projectTypes || []).map(type => ({
        label: this.translateDynamicMenuLabel('App\\Project\\Project-type', type.name),
        icon: 'pi pi-angle-right',
        url: `/#/project?from=projecttype&project_type=${type.id}&project_type_name=${encodeURIComponent(type.name)}`,
      }));
      const projectMenu =
        {
          label: this.props.t('App\\Project\\Menu'),
          icon: 'pi pi-fw pi-clone',
          className: currentHref.includes('/#/project') ? 'active-menu-item project' : 'project',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            ...(
            (localStorage.getItem('roles') || '').includes('role_project_read')
              ? [
                  {
                    label: this.props.t('App\\Project'),
                    icon: 'pi pi-list',
                    url: '/#/project',
                  },
                  ...projectTypeMenuItems,
                ]
              : []
            ),
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_offer_read') ?
            {
              label: this.props.t('App\\Project\\Offer'),
              icon: 'pi pi-list',
              url: '/#/project/offer',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_project_contract_read') ?
            {
              label: this.props.t('App\\Project\\Contract'),
              icon: 'pi pi-list',
              url: '/#/project/contract',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_project_type_read') ?
            {
              label: this.props.t('App\\Project\\Project-type'),
              icon: 'pi pi-cog',
              url: '/#/project/project-type',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_project_status_read') ?
            {
              label: this.props.t('App\\Project\\Project-status'),
              icon: 'pi pi-cog',
              url: '/#/project/project-status',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_project_item_status_read') ?
            {
              label: this.props.t('App\\Project\\Project-item-status'),
              icon: 'pi pi-cog',
              url: '/#/project/project-item-status',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_technology_read') ?
            {
              label: this.props.t('App\\Project\\Technology'),
              icon: 'pi pi-cog',
              url: '/#/project/technology',
            } : null,
          ]).filter(Boolean)
        };
        if (projectMenu.items.some(item => !item.separator)) {
          this.menu.push(projectMenu);
        }
    }
    if (localStorage.getItem('module_manufacturing')) {
      let _dashboard = []
      if (localStorage.getItem('modulemanufacturing_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Production\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/production/dashboard?summaryId=' + localStorage.getItem('module_manufacturing_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const manufacturingMenu = 
        {
          label: this.props.t('App\\Production\\Menu'),
          icon: 'pi pi-plus',
          className: currentHref.includes('/#/production') ? 'active-menu-item production' : 'production',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            (localStorage.getItem('roles') || '[]').includes('role_production_status_read') ?
            {
              label: this.props.t('App\\Production\\Production-status'),
              icon: 'pi pi-list',
              url: '/#/production/production-status',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_schedule_read') ?
            {
              label: this.props.t('App\\Production\\Schedule-group'),
              icon: 'pi pi-list',
              url: '/#/production/schedule-group',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_schedule_item_read') ?
            {
              label: this.props.t('App\\Production\\Schedule-item'),
              icon: 'pi pi-list',
              url: '/#/production/schedule-item',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_production_project_item_read') ?
            {
              label: this.props.t('App\\Production\\Project-item'),
              icon: 'pi pi-list',
              url: '/#/production/project-item',
            }: null,
            (localStorage.getItem('roles') || '[]').includes('role_production_overview_read') ?
            {
              label: this.props.t('App\\Production\\Productionoverview'),
              icon: 'pi pi-list',
              url: '/#/production/productionoverview',
            } : null,
            {
              label: this.props.t('App\\Production\\Production-items'),
              icon: 'pi pi-list',
              url: '/#/production/production-items',
            },
            {
              label: this.props.t('App\\Production\\Cooperation'),
              icon: 'pi pi-list',
              url: '/#/production/cooperation',
            },
            (localStorage.getItem('roles') || '[]').includes('role_') ?
            {
              label: this.props.t('App\\Production\\Track-log'),
              icon: 'pi pi-list',
              url: '/#/production/track-log',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_machine_log_read') ?
            {
              label: this.props.t('App\\Production\\Machine-log'),
              icon: 'pi pi-list',
              url: '/#/production/machine-log',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_metrics_read') ?
            {
              label: this.props.t('App\\Production\\Metrics'),
              icon: 'pi pi-cog',
              url: '/#/production/metrics',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_floor_plan_read') ?
            {
              label: this.props.t('App\\Production\\Floor-plan'),
              icon: 'pi pi-cog',
              url: '/#/production/floor-plan',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_machine_read') ?
            {
              label: this.props.t('App\\Production\\Machine'),
              icon: 'pi pi-cog',
              url: '/#/production/machine',
            } : null,
          ]).filter(Boolean)
        };
        if (manufacturingMenu.items.some(item => !item.separator)) {
          this.menu.push(manufacturingMenu);
        }
    }
    if (localStorage.getItem('module_hr')) {
      let _dashboard = []
      if (localStorage.getItem('module_hr_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Hr\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/hr/dashboard?summaryId=' + localStorage.getItem('module_hr_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const hrMenu =
        {
          label: this.props.t('App\\Hr\\Menu'),
          icon: 'pi pi-users',
          className: currentHref.includes('/#/hr') ? 'active-menu-item hr' : 'hr',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            (localStorage.getItem('roles') || '[]').includes('role_employee_read') ?
            {
              label: this.props.t('App\\Hr\\Employee'),
              icon: 'pi pi-list',
              url: '/#/hr/employee',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_hr_calendar_read') ?
            {
              label: this.props.t('App\\Hr\\Calendar'),
              icon: 'pi pi-list',
              url: '/#/hr/calendar',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_checkin_read') ?
            {
              label: this.props.t('App\\Hr\\Checkin'),
              icon: 'pi pi-list',
              url: '/#/hr/checkin',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_hr_docs_read') ?
            {
              label: this.props.t('App\\Hr\\Docs'),
              icon: 'pi pi-list',
              url: '/#/hr/docs',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_compilance_read') ?
            {
              label: this.props.t('App\\Hr\\Compilance'),
              icon: 'pi pi-list',
              url: '/#/hr/compilance',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_employment_read') ?
            {
              label: this.props.t('App\\Hr\\Employment'),
              icon: 'pi pi-list',
              url: '/#/hr/employment',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_payroll_read') ?
            {
              label: this.props.t('App\\Hr\\Payroll'),
              icon: 'pi pi-list',
              url: '/#/hr/payroll',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_simplified_employment_read') ?
            {
              label: this.props.t('App\\Hr\\Simplified-employment'),
              icon: 'pi pi-list',
              url: '/#/hr/simplified-employment',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_employment_type_read') ?
            {
              label: this.props.t('App\\Hr\\Employment-type'),
              icon: 'pi pi-cog',
              url: '/#/hr/employment-type',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_employee_position_read') ?
            {
              label: this.props.t('App\\Hr\\Employee-position'),
              icon: 'pi pi-cog',
              url: '/#/hr/employee-position',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_citizenship_read') ?
            {
              label: this.props.t('App\\Hr\\Citizenship'),
              icon: 'pi pi-cog',
              url: '/#/hr/citizenship',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_hr_calendar_category_read') ?
            {
              label: this.props.t('App\\Hr\\Calendar-category'),
              icon: 'pi pi-cog',
              url: '/#/hr/calendar-category',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_compilance_category_read') ?
            {
              label: this.props.t('App\\Hr\\Compilance-category'),
              icon: 'pi pi-cog',
              url: '/#/hr/compilance-category',
            } : null,
          ]).filter(Boolean)
        };
        if (hrMenu.items.some(item => !item.separator)) {
          this.menu.push(hrMenu);
        }
    }
    if (localStorage.getItem('module_hr')) {
      const docsMenu =
        {
          label: this.props.t('App\\Docs\\Menu'),
          icon: 'pi pi-fw pi-file',
          className: currentHref.includes('/#/docs') ? 'active-menu-item docs' : 'docs',
          items: this.cleanMenuItems([
            (localStorage.getItem('roles') || '[]').includes('role_docs_read') ?
            {
              label: this.props.t('App\\Docs'),
              icon: 'pi pi-list',
              url: '/#/docs',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_docs_category_read') ?
            {
              label: this.props.t('App\\Docs\\Category'),
              icon: 'pi pi-cog',
              url: '/#/docs/category',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_docs_template_read') ?
            {
              label: this.props.t('App\\Docs\\Template'),
              icon: 'pi pi-cog',
              url: '/#/docs/template',
            } : null,
          ]).filter(Boolean)
        };
        if (docsMenu.items.some(item => !item.separator)) {
          this.menu.push(docsMenu);
        }
    }
    if (localStorage.getItem('module_finance')) {
      let _dashboard = []
      if (localStorage.getItem('module_finance_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Finance\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/finance/dashboard?summaryId=' + localStorage.getItem('module_finance_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      // const receiptGroupMenuItems = (this.state.receiptGroups || []).map(group => ({
      //   label: group.name,
      //   icon: 'pi pi-angle-right',
      //   url: `/#/finance?from=receiptgroup&receipt_type=${group.receipt_type}&receipt_group=${group.id}`,
      // }));
      const receiptGroupMenuItems = (this.state.receiptGroups || []).map(group => ({
        label: group.name,
        icon: 'pi pi-angle-right',
        url: `/#/finance?from=receiptgroup&receipt_type=${group.receipt_type}&receipt_group=${group.id}&receipt_group_name=${encodeURIComponent(group.name)}`,
      }));
      const financeMenu =
        {
          label: this.props.t('App\\Finance\\Menu'),
          icon: 'pi pi-fw pi-wallet',
          className: currentHref.includes('/#/finance') ? 'active-menu-item finance' : 'finance',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            ...(
            (localStorage.getItem('roles') || '').includes('role_receipt_read')
              ? [
                  {
                    label: this.props.t('App\\Finance'),
                    icon: 'pi pi-list',
                    url: '/#/finance',
                    },
                    ...receiptGroupMenuItems,
                  ]
              : []
            ),
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            (localStorage.getItem('roles') || '[]').includes('role_invoice_approval_read') ? 
            {
              label: this.props.t('App\\Finance\\Invoice-approval'),
              icon: 'pi pi-list',
              url: '/#/finance/invoice-approval',
            } : null,
            localStorage.getItem('roles').toString().includes('role_bank_transaction_read') ? 
            {
              label: this.props.t('App\\Finance\\Bank-transaction'),
              icon: 'pi pi-list',
              url: '/#/finance/bank-transaction',
            } : null,
            localStorage.getItem('roles').toString().includes('role_retention_read') ? 
            {
              label: this.props.t('App\\Finance\\Retention'),
              icon: 'pi pi-list',
              url: '/#/finance/retention',
            } : null,
            localStorage.getItem('roles').toString().includes('role_cost_item_read') ?
            {
              label: this.props.t('App\\Finance\\Cost-item'),
              icon: 'pi pi-list',
              url: '/#/finance/cost-item',
            } : null,
            localStorage.getItem('roles').toString().includes('role_cost_allocation_read') ?
            {
              label: this.props.t('App\\Finance\\Cost-allocation'),
              icon: 'pi pi-list',
              url: '/#/finance/cost-allocation',
            } : null,
            localStorage.getItem('roles').toString().includes('role_revenue_item_read') ?
            {
              label: this.props.t('App\\Finance\\Revenue-item'),
              icon: 'pi pi-list',
              url: '/#/finance/revenue-item',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            localStorage.getItem('roles').toString().includes('role_receipt_group_read') ? 
            {
              label: this.props.t('App\\Finance\\Book'),
              icon: 'pi pi-cog',
              url: '/#/finance/book',
            } : null,
            localStorage.getItem('roles').toString().includes('role_retention_category_read') ?
            {
              label: this.props.t('App\\Finance\\Retention-category'),
              icon: 'pi pi-cog',
              url: '/#/finance/retention-category',
            } : null,
            localStorage.getItem('roles').toString().includes('role_payment_method_read') ?
            {
              label: this.props.t('App\\Finance\\Payment-method'),
              icon: 'pi pi-cog',
              url: '/#/finance/payment-method',
            } : null,
            localStorage.getItem('roles').toString().includes('role_profit_center_read') ?
            {
              label: this.props.t('App\\Finance\\Profit-center'),
              icon: 'pi pi-cog',
              url: '/#/finance/profit-center',
            } : null,
            localStorage.getItem('roles').toString().includes('role_cost_type_read') ?
            {
              label: this.props.t('App\\Finance\\Cost-type'),
              icon: 'pi pi-cog',
              url: '/#/finance/cost-type',
            } : null,
            localStorage.getItem('roles').toString().includes('role_cost_center_read') ?
            {
              label: this.props.t('App\\Finance\\Cost-center'),
              icon: 'pi pi-cog',
              url: '/#/finance/cost-center',
            } : null,
            localStorage.getItem('roles').toString().includes('role_bank_account_read') ?
            {
              label: this.props.t('App\\Finance\\Bank-account'),
              icon: 'pi pi-cog',
              url: '/#/finance/bank-account',
            } : null,
            localStorage.getItem('roles').toString().includes('role_vat_rate_read') ?
            {
              label: this.props.t('App\\Finance\\Vat-rate'),
              icon: 'pi pi-cog',
              url: '/#/finance/vat-rate',
            } : null,
            localStorage.getItem('roles').toString().includes('role_exchange_rate_read') ?
            {
              label: this.props.t('App\\Finance\\Exchange-rate'),
              icon: 'pi pi-cog',
              url: '/#/finance/exchange-rate',
            } : null,
            localStorage.getItem('roles').toString().includes('role_') ?
            {
              label: this.props.t('App\\Finance\\Receipt-import'),
              icon: 'pi pi-cog',
              url: '/#/finance/receipt-import',
            } : null,
          ]).filter(Boolean)
        };
        if (financeMenu.items.some(item => !item.separator)) {
          this.menu.push(financeMenu);
        }
    }
    if (localStorage.getItem('module_inventory')) {
      let _dashboard = []
      if (localStorage.getItem('module_inventory_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Inventory\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/inventory/dashboard?summaryId=' + localStorage.getItem('module_inventory_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const inventoryMenu =
        {
          label: this.props.t('App\\Inventory\\Menu'),
          icon: 'pi pi-fw pi-th-large',
          className: currentHref.includes('/#/inventory') ? 'active-menu-item inventory' : 'inventory',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            localStorage.getItem('roles').toString().includes('role_inventory_read') ? 
            {
              label: this.props.t('App\\Inventory\\Inventory'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_movement_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-movement'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-movement',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            ...[
              materialMaster ? {
                label: this.props.t('App\\Inventory\\Material\\Master'),
                icon: 'pi pi-list',
                url: '/#/inventory/material?view=master'
              } : null,
              materialTrading ? {
                label: this.props.t('App\\Inventory\\Material\\Trading'),
                icon: 'pi pi-angle-right',
                url: '/#/inventory/material?view=trading'
              } : null,
              materialProduction ? {
                label: this.props.t('App\\Inventory\\Material\\Production'),
                icon: 'pi pi-angle-right',
                url: '/#/inventory/material?view=production'
              } : null,
              materialOperations ? {
                label: this.props.t('App\\Inventory\\Material\\Operations'),
                icon: 'pi pi-angle-right',
                url: '/#/inventory/material?view=operations'
              } : null,
            ].filter(Boolean),
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            localStorage.getItem('roles').toString().includes('role_inventory_supplier_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Transfer-supplier'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=transfer_supplier',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_delivery_note_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Delivery-note'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=delivery_note',
            } : null,
            // localStorage.getItem('roles').toString().includes('role_inventory_grn_read') ?
            // {
            //   label: this.props.t('App\\Inventory\\Inventory-grn'),
            //   icon: 'pi pi-list',
            //   url: '/#/inventory/inventory-grn',
            // } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_pick_list_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Pick-list'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=pick_list',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_relocation_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Relocation'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=relocation',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_transfer_2st_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Transfer-2st'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=transfer_2st',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_scrap_note_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Scrap-note'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=scrap_note',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_inventory_count_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Inventory-count'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=inventory_count',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_return_by_customer_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Return-by-customer'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=return_by_customer',
            } : null,
            localStorage.getItem('roles').toString().includes('role_inventory_return_to_supplier_read') ?
            {
              label: this.props.t('App\\Inventory\\Inventory-document\\Return-to-supplier'),
              icon: 'pi pi-list',
              url: '/#/inventory/inventory-document?view=return_to_supplier',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            localStorage.getItem('roles').toString().includes('role_inventory_material_category_read') ?
            {
              label: this.props.t('App\\Inventory\\Material-category'),
              icon: 'pi pi-cog',
              url: '/#/inventory/material-category',
            } : null,
            localStorage.getItem('roles').toString().includes('role_warehouse_read') ?
            {
              label: this.props.t('App\\Inventory\\Warehouse'),
              icon: 'pi pi-cog',
              url: '/#/inventory/warehouse',
            } : null,
            localStorage.getItem('roles').toString().includes('role_manufacturer_read') ?
            {
              label: this.props.t('App\\Inventory\\Manufacturer'),
              icon: 'pi pi-cog',
              url: '/#/inventory/manufacturer',
            } : null,
            localStorage.getItem('roles').toString().includes('role_import_read') ?
            {
              label: this.props.t('App\\Inventory\\Import'),
              icon: 'pi pi-cog',
              url: '/#/inventory/import',
            } : null,
            materialSupplierPriceRead ? {
              label: this.props.t('App\\Inventory\\Material-supplier-price'),
              icon: 'pi pi-money-bill',
              url: '/#/inventory/material-supplier-price',
            } : null,
          ]).filter(Boolean)
        };
        if (inventoryMenu.items.some(item => !item.separator)) {
          this.menu.push(inventoryMenu);
        }
    }
    if (localStorage.getItem('module_procurement')) {
      let _dashboard = []
      if (localStorage.getItem('module_procurement_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Procurement\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/procurement/dashboard?summaryId=' + localStorage.getItem('module_procurement_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const procurementMenu =
        {
          label: this.props.t('App\\Procurement\\Menu'),
          icon: 'pi pi-fw pi-shopping-cart',
          className: currentHref.includes('/#/procurement') ? 'active-menu-item procurement' : 'procurement',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            localStorage.getItem('roles').toString().includes('role_purchase_order_req_read') ?
            {
              label: this.props.t('App\\Procurement\\Purchase-request'),
              icon: 'pi pi-list',
              url: '/#/procurement/purchase-request',
            } : null,
            localStorage.getItem('roles').toString().includes('role_purchase_order_read') ?
            {
              label: this.props.t('App\\Procurement\\Purchase-order'),
              icon: 'pi pi-list',
              url: '/#/procurement/purchase-order',
            } : null,
            {
              separator: true,
              template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            },
            localStorage.getItem('roles').toString().includes('role_purchase_substitution_read') ?
            {
              label: this.props.t('App\\Procurement\\Substitution'),
              icon: 'pi pi-cog',
              url: '/#/procurement/substitution',
            } : null,
          ]).filter(Boolean)
        };
        if (procurementMenu.items.some(item => !item.separator)) {
          this.menu.push(procurementMenu);
        }
    }
    if (localStorage.getItem('module_recruitment')) {
      let _dashboard = []
      if (localStorage.getItem('module_recruitment_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Recruitment\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/recruitment/dashboard?summaryId=' + localStorage.getItem('module_recruitment_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const recruitmentMenu =
        {
          label: this.props.t('App\\Recruitment\\Menu'),
          icon: 'pi pi-user-plus',
          className: currentHref.includes('/#/recruitment') ? 'active-menu-item recruitment' : 'recruitment',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            (localStorage.getItem('roles') || '[]').includes('role_recruitment_candidate_read') ?
            {
              label: this.props.t('App\\Recruitment\\Candidate'),
              icon: 'pi pi-list',
              url: '/#/recruitment/candidate',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_recruitment_read') ?
            {
              label: this.props.t('App\\Recruitment\\Recruitment'),
              icon: 'pi pi-list',
              url: '/#/recruitment/recruitment',
            } : null,
            (localStorage.getItem('roles') || '[]').includes('role_recruitment_event_type_status_read') ?
            {
              label: this.props.t('App\\Recruitment\\Event-type-status'),
              icon: 'pi pi-list',
              url: '/#/recruitment/event-type-status',
            } : null,
            {
              label: this.props.t('App\\Recruitment\\Language'),
              icon: 'pi pi-list',
              url: '/#/recruitment/language',
            },
            (localStorage.getItem('roles') || '[]').includes('role_recruitment_event_type_read') ?
            {
              label: this.props.t('App\\Recruitment\\Event-type'),
              icon: 'pi pi-list',
              url: '/#/recruitment/event-type',
            } : null,
          ]).filter(Boolean)
        };
        if (recruitmentMenu.items.some(item => !item.separator)) {
          this.menu.push(recruitmentMenu);
        }
    }
    if (localStorage.getItem('module_settings')) {
      let _dashboard = []
      if (localStorage.getItem('module_settings_dashboard')) {
        _dashboard = [
          {
            label: this.props.t('App\\Settings\\Dashboard'),
            icon: 'pi pi-chart-bar',
            url: '/#/settings/dashboard?summaryId=' + localStorage.getItem('module_settings_dashboard'),
          },
          {
            separator: true,
            template: () => <div className="p-menu-separator"></div> // Egyedi separator element
          }
        ]
      }
      const settingsMenu = 
        {
          label: this.props.t('App\\Settings\\Menu'),
          icon: 'pi pi-fw pi-cog',
          className: currentHref.includes('/#/settings') ? 'active-menu-item settings' : 'settings',
          items: this.cleanMenuItems([
            ...(_dashboard.length > 0 ? _dashboard : []),
            localStorage.getItem('roles').toString().includes('role_user_read') ?
            {
              label: this.props.t('App\\Settings\\User'),
              icon: 'pi pi-cog',
              url: '/#/settings/user',
            } : null,
            localStorage.getItem('roles').toString().includes('role_company_read') ?
            {
              label: this.props.t('App\\Settings\\Company'),
              icon: 'pi pi-cog',
              url: '/#/settings/company',
            } : null,
            localStorage.getItem('roles').toString().includes('role_role_group_read') ?
            {
              label: this.props.t('App\\Settings\\Roles'),
              icon: 'pi pi-cog',
              url: '/#/settings/roles',
            } : null,
            localStorage.getItem('roles').toString().includes('role_unit_read') ?
            {
              label: this.props.t('App\\Settings\\Unit'),
              icon: 'pi pi-cog',
              url: '/#/settings/unit',
            } : null,
            localStorage.getItem('roles').toString().includes('role_location_read') ?
            {
              label: this.props.t('App\\Settings\\Location'),
              icon: 'pi pi-cog',
              url: '/#/settings/location',
            } : null,
            localStorage.getItem('roles').toString().includes('role_price_list_item_read') ?
            {
              label: this.props.t('App\\Settings\\Price-list-item'),
              icon: 'pi pi-cog',
              url: '/#/settings/price-list-item',
            } : null,
            localStorage.getItem('roles').toString().includes('role_identifier_read') ?
            {
              label: this.props.t('App\\Settings\\Identifier'),
              icon: 'pi pi-cog',
              url: '/#/settings/identifier',
            } : null,
            localStorage.getItem('roles').toString().includes('role_dashboard_template_read') ?
            {
              label: this.props.t('App\\Settings\\Dashboard-template'),
              icon: 'pi pi-cog',
              url: '/#/settings/dashboard-template',
            } : null,
            localStorage.getItem('roles').toString().includes('role_') ?
            {
              label: this.props.t('App\\Settings\\System-settings'),
              icon: 'pi pi-cog',
              command: () => {
                this.setState({
                  sidebarSystemSettings: true
                });
              }
            } : null,
            // {
            //   separator: true,
            //   template: () => <div className="p-menu-separator"></div> // Egyedi separator element
            // },
            // {
            //   label: 'Kiváltás jogcímek',
            //   icon: 'pi pi-cog',
            //   url: '/#/procurement/substitution',
            // },
          ]).filter(Boolean)
        };
        if (settingsMenu.items.some(item => !item.separator)) {
          this.menu.push(settingsMenu)
        }
    }

    // old
    if (localStorage.getItem('module_order')) {
      this.menu.push(
        {
          label: localStorage.getItem('module_order'),
          icon: 'pi pi-fw pi-shopping-cart',
          url: '/#/order',
          className: 'order'
        }
      )
    }
    if (localStorage.getItem('module_maintenance')) {
      this.menu.push(
        {
          label: localStorage.getItem('module_maintenance'),
          icon: 'pi pi-fw pi-tag',
          url: '/#/maintenance',
          className: currentHref.includes('/#/maintenance') ? 'active-menu-item maintenance' : 'maintenance',
        }
      )
    }
    // if (localStorage.getItem('module_settings')) {
    //   this.menu.push(
    //     {
    //       label: localStorage.getItem('module_settings'),
    //       icon: 'pi pi-fw pi-cog',
    //       url: '/#/settings',
    //       className: currentHref.includes('/#/settings') ? 'active-menu-item settings' : 'settings',
    //     }
    //   )
    // }
    if (process.env.REACT_APP_BRAND !== 'brw' && localStorage.getItem('module_report')) {
      this.menu.push(
        {
          label: localStorage.getItem('module_report'),
          icon: 'pi pi-fw pi-chart-line',
          url: '/#/report',
          className: currentHref.includes('/#/report') ? 'active-menu-item report' : 'report',
        }
      )
    }
    if (localStorage.getItem('module_track_log')) {
      this.menu.push(
        {
          label: localStorage.getItem('module_track_log'),
          icon: 'pi pi-database',
          url: '/#/tracklog',
          className: currentHref.includes('/#/tracklog') ? 'active-menu-item tracklog' : 'tracklog',
        }
      )
    }
    if (localStorage.getItem('module_support')) {
      this.menu.push(
        {
          label: localStorage.getItem('module_support'),
          icon: 'pi pi-fw pi-question-circle',
          url: '/#/support',
          className: currentHref.includes('/#/support') ? 'active-menu-item support' : 'support',
        }
      )
    }
    return this.menu;
  }

  pageHeight = () => {
    //tabview sroll
    setTimeout(function () {
      if (document.getElementById('tabScroll')) {
        if (document.getElementById('tabScroll').scrollWidth >
          document.getElementById('tabScroll').parentElement.offsetWidth) {
          window.App.setState({tabScroll: true})
        } else {
          window.App.setState({tabScroll: false})
        }
      }
    }, 500)

    //page height
    if (window.innerWidth > 1200) {
      let headerHight = 52
      let windowHeight = window.innerHeight
      let pageHeight = windowHeight - headerHight
      if (document.getElementById("page")) {
        document.getElementById("page").getElementsByClassName("DashboardPage")[0].style.cssText
          = "height:" + pageHeight + "px !important";
      }
    }
    window.addEventListener('resize', function (event) {
      if (window.innerWidth > 1200) {
        let headerHight = 52
        let windowHeight = window.innerHeight
        let pageHeight = windowHeight - headerHight
        if (document.getElementById("page")) {
          document.getElementById("page").getElementsByClassName("DashboardPage")[0].style.cssText
            = "height:" + pageHeight + "px !important";
        }
      }
    })
  }

  transformQueryParams(lazyParams) {
    let query = '?'
    if (lazyParams.sortField) {
      query += 'sort=' + lazyParams.sortField.toLowerCase().replaceAll('.', '_')
    }
    if (lazyParams.sortOrder) {
      if (lazyParams.sortOrder == 1) {
        query += '&direction=asc'
      }
      if (lazyParams.sortOrder == -1) {
        query += '&direction=desc'
      }
    }
    if (lazyParams.filters) {
      delete lazyParams.genericSearch
      Object.entries(lazyParams.filters).map(function (filter, index) {
        if (filter[1]?.value !== null) {
          let _filter = filter[0].replaceAll('.', '_')
          // if(filter[0].includes('.')) {
          //   _filter = 'e.' + filter[0].toLowerCase()
          // } else {
          //   _filter = filter[0].toLowerCase()
          // }
          if (filter[1].matchMode === 'like') {
            query += '&search[' + _filter + '][operator]=' + filter[1].matchMode + '&search[' + _filter
              + '][value]=*' + filter[1].value + '*'
          } else if (filter[1].matchMode === 'startsWith') {
            query += '&search[' + _filter + '][operator]=like' + '&search[' + _filter
              + '][value]=*' + filter[1].value + '*'
          } else if (filter[1].matchMode === 'equals') {
            if (_filter === 'receipt_group') {
                 query += '&search[' + _filter + '][operator]=%3D&search[' + _filter + '][value][]=' + filter[1].value
            } else {
                 query += '&search[' + _filter + '][operator]=%3D&search[' + _filter + '][value]=' + filter[1].value
            }
          } else {
            query += '&search[' + _filter + ']&search[' + _filter + '][value]=' + filter[1].value
          }
        }
      })
    }
    if (lazyParams.is_active === 1 || lazyParams.is_active === 0) {
      query += '&search[is_active]=' + lazyParams.is_active
    }
    if (lazyParams.search) {
      query += '&search=' + lazyParams.search
    }
    if (lazyParams.genericSearch && !lazyParams.filters) {
      query += '&genericSearch=' + lazyParams.genericSearch
    }
    if (lazyParams.rows) {
      query += '&item_per_page=' + lazyParams.rows
    }
    if (lazyParams.page) {
      query += '&page=' + Number(lazyParams.page + 1)
    }
    return (query)
  }

  cleanMenuItems = (items) => {
    const result = [];
    (items || []).filter(Boolean).forEach((item) => {
      if (item.separator) {
        if (result.length === 0) return;
        if (result[result.length - 1].separator) return;
      }
      result.push(item);
    });
    if (result.length > 0 && result[result.length - 1].separator) {
      result.pop();
    }
    return result;
  }

  // attachAxiosInterceptors = () => {
  //   if (window.__axiosInterceptorsAttached) {
  //     return;
  //   }
  //   window.__axiosInterceptorsAttached = true;
  //   axios.interceptors.request.use(
  //     async (config) => {
  //       const token = localStorage.getItem('userToken');
  //       const refreshToken = localStorage.getItem('refreshToken');
  //       if (token) {
  //         config.headers = config.headers || {};
  //         if (!config.headers['Authorization']) {
  //           config.headers['Authorization'] = 'Bearer ' + token;
  //         }
  //       }
  //       if (!token || !refreshToken) {
  //         return config;
  //       }
  //       const url = config.url || '';
  //       const isAuthRequest =
  //         url.includes('/login') ||
  //         url.includes('/password-reset') ||
  //         url.includes('/password-set') ||
  //         url.includes('/api/token/refresh');
  //       if (isAuthRequest) {
  //         return config;
  //       }
  //       if (window.__disableTokenRefresh === true) {
  //         return config;
  //       }
  //       try {
  //         const refreshResponse = await axios.post(
  //           process.env.REACT_APP_API_HOST + '/api/token/refresh',
  //           {
  //             refresh_token: refreshToken
  //           }
  //         );
  //         const data = refreshResponse.data || {};
  //         if (data.token) {
  //           localStorage.setItem('userToken', data.token);
  //         }
  //         if (data.refresh_token) {
  //           localStorage.setItem('refreshToken', data.refresh_token);
  //         }
  //         if (data.refresh_token_expiration) {
  //           localStorage.setItem(
  //             'refreshTokenExpiration',
  //             String(data.refresh_token_expiration)
  //           );
  //         }
  //         if (window.App && typeof window.App.setupAutoLogout === 'function') {
  //           window.App.setupAutoLogout();
  //         }
  //         const newToken = localStorage.getItem('userToken');
  //         if (newToken) {
  //           config.headers = config.headers || {};
  //           config.headers['Authorization'] = 'Bearer ' + newToken;
  //         }

  //         return config;
  //       } catch (error) {
  //         if (error.response && error.response.status === 404) {
  //           console.warn('Refresh endpoint 404, refresh kikapcsolva, marad a régi token + timer.');
  //           window.__disableTokenRefresh = true;
  //           return config;
  //         }
  //         console.error('Token refresh error:', error);
  //         if (window.App && typeof window.App.forceSessionExpiredLogout === 'function') {
  //           window.App.forceSessionExpiredLogout();
  //         }
  //         return Promise.reject(error);
  //       }
  //     },
  //     (error) => Promise.reject(error)
  //   );
  // };
  attachAxiosInterceptors = () => {
    if (window.__axiosInterceptorsAttached) return;
    window.__axiosInterceptorsAttached = true;
    const THRESHOLD_SEC = 60;
    const expSec = (jwt) => {
      try {
        const p = jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(atob(p.padEnd(p.length + (4 - (p.length % 4)) % 4, "="))).exp ?? null;
      } catch { return null; }
    };
    window.__refreshPromise ||= null;
    axios.interceptors.request.use(async (config) => {
      const token = localStorage.getItem("userToken");
      const refreshToken = localStorage.getItem("refreshToken");
      config.headers ||= {};
      if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
      if (!token || !refreshToken) return config;
      const url = config.url || "";
      if (url.includes("/login") || url.includes("/password-") || url.includes("/api/token/refresh")) return config;
      if (window.__disableTokenRefresh) return config;
      const exp = expSec(token);
      const remaining = exp ? (exp - Math.floor(Date.now() / 1000)) : null;
      if (remaining === null || remaining > THRESHOLD_SEC) return config;
      try {
        window.__refreshPromise ||= axios
          .post(process.env.REACT_APP_API_HOST + "/api/token/refresh", { refresh_token: refreshToken })
          .then(r => {
            const d = r.data || {};
            if (d.token) localStorage.setItem("userToken", d.token);
            if (d.refresh_token) localStorage.setItem("refreshToken", d.refresh_token);
            if (window.App?.setupAutoLogout) window.App.setupAutoLogout();
            return d.token;
          })
          .finally(() => (window.__refreshPromise = null));
        const newToken = await window.__refreshPromise;
        if (newToken) config.headers.Authorization = `Bearer ${newToken}`;
        return config;
      } catch (e) {
        if (e?.response?.status === 404) { 
          window.__disableTokenRefresh = true; 
          return config; 
        }
        e.__sessionExpired = true;
        window.App?.forceSessionExpiredLogout?.();
        return Promise.reject(e);
      }
    });
  };

  setupAutoLogout = () => {
    const token = localStorage.getItem('userToken');
    const refreshToken = localStorage.getItem('refreshToken');
    if (!token && !refreshToken) {
      if (this.logoutTimeoutId) {
        clearTimeout(this.logoutTimeoutId);
        this.logoutTimeoutId = null;
      }
      if (this.logoutIntervalId) {
        clearInterval(this.logoutIntervalId);
        this.logoutIntervalId = null;
      }
      return;
    }
    this.checkTokenAndLogoutIfExpired();
    if (!localStorage.getItem('userToken') && !localStorage.getItem('refreshToken')) {
      return;
    }
    if (this.logoutTimeoutId) {
      clearTimeout(this.logoutTimeoutId);
      this.logoutTimeoutId = null;
    }
    if (this.logoutIntervalId) {
      clearInterval(this.logoutIntervalId);
      this.logoutIntervalId = null;
    }
    this.logoutIntervalId = setInterval(() => {
      this.checkTokenAndLogoutIfExpired();
    }, 1000);
  }

  networkSelect = () => {
    if (localStorage.getItem('userToken')) {
      axios.get(process.env.REACT_APP_API_HOST + '/api/v2/networks', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
        }
      })
        .then(response => {
          if (response.data && response.data[0]) {
            window.App.setState({
              networks: response.data
            })
            if (!localStorage.getItem('networkId') && !localStorage.getItem('networkName')) {
              localStorage.setItem('networkId', response.data[0].id)
              localStorage.setItem('networkName', response.data[0].name)
            }
            this.loadProjectTypes();
          }
          axios.get(process.env.REACT_APP_API_HOST + '/api/v2/modules', {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
              'App-Network': localStorage.getItem('networkId') || ''
            }
          })
            .then(response => {
              Object.keys(localStorage)
                .filter(key => key.startsWith("module_"))
                .forEach(key => localStorage
                  .removeItem((key)))

              // Object.entries(response.data).map(function (item, index) {
              //   localStorage.setItem('module_' + item[1].code, item[1].name);
              //   localStorage.setItem('module_' + item[1].code + '_dashboard', item[1]?.dashboard?.id);
              // })

              Object.entries(response.data).forEach(([_, mod]) => {
                localStorage.setItem('module_' + mod.code, mod.name);
                const dashId = mod?.dashboard?.id;
                const dashKey = 'module_' + mod.code + '_dashboard';
                if (dashId) {
                  localStorage.setItem(dashKey, String(dashId));
                } else {
                  localStorage.removeItem(dashKey);
                }
              });
              // if (localStorage.getItem('module_finance')) {
              //   this.loadReceiptGroups();
              // }
              window.App.forceUpdate()
            })
            .catch(error => {
              window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
            })
          window.App.forceUpdate()
          if (localStorage.getItem('userToken') && process.env.REACT_APP_SUBSCRIPTION_MESSAGES === "enabled") {
            NetworkSubscriptionMessageService()
              .then(response => {
                window.App.setState({
                  subscriptionMessages: response.data
                })
              })
              .catch(error => {
                // window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
              })
          }
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }
    window.App.forceUpdate()
  }

  // currencyFormatter = (currency, amount) => {
  //   let currencyFormat
  //   if (currency === 'HUF') {
  //     currencyFormat = {
  //       precision: 2,
  //       symbol: '',
  //       decimal: ',',
  //       thousand: ' ',
  //     }
  //   } else {
  //     currencyFormat = {
  //       precision: 2,
  //       symbol: '',
  //       decimal: '.',
  //       thousand: ' ',
  //     }
  //   }
  //   return (
  //     <>
  //       {currencyFormatter.format(
  //         amount, {
  //           precision: currencyFormat.precision,
  //           symbol: currencyFormat.symbol,
  //           decimal: currencyFormat.decimal,
  //           thousand: currencyFormat.thousand,
  //         }
  //       )}&nbsp;{currency}
  //     </>
  //   )
  // }
  currencyFormatter = (currency, amount) => {
    const locale = (localStorage.getItem('user.locale') || localStorage.getItem('userLocale') || 'hu').toString().toLowerCase()
    const ccy = (currency || '').toString().toUpperCase()
    let precision = 2
    if (ccy === 'HUF') {
      precision = 0
    }
    const SYMBOLS = { HUF: 'Ft', EUR: '€', USD: '$', GBP: '£' }
    const symbol = SYMBOLS[ccy] || ccy
    let decimal = ','
    let thousand = ' '
    if (locale.startsWith('en')) {
      decimal = '.'
      thousand = ','
    }
    const n = Number(amount)
    const safe = Number.isFinite(n) ? n : 0
    return (
      <>
        {currencyFormatter.format(
          safe,
          {
            precision: precision,
            symbol: '',
            decimal: decimal,
            thousand: thousand,
          }
        )}&nbsp;{symbol}
      </>
    )
  }

  sortDropdownOptions = (options, optionLabel) => {
    if (!Array.isArray(options) || !optionLabel) return options;
    const getValue = (option) => optionLabel.split('.').reduce((value, key) => value?.[key], option);
    return [...options].sort((a, b) =>
      String(getValue(a) || '').localeCompare(String(getValue(b) || ''), 'hu', {sensitivity: 'base', numeric: true})
    );
  }

  getScaleValue = () => {
    const savedScale = localStorage.getItem('scale');
    if (savedScale !== null && savedScale !== undefined && savedScale !== '') {
      return Number(savedScale);
    }
    const currentFontSize = parseFloat(
      window.getComputedStyle(document.documentElement).fontSize
    );
    const scaleMap = [
      { scale: 0, fontSize: 10 },
      { scale: 20, fontSize: 12 },
      { scale: 40, fontSize: 14 },
      { scale: 60, fontSize: 15 },
      { scale: 80, fontSize: 16 },
      { scale: 100, fontSize: 17 },
    ];
    const closest = scaleMap.reduce((prev, curr) => {
      return Math.abs(curr.fontSize - currentFontSize) < Math.abs(prev.fontSize - currentFontSize)
        ? curr
        : prev;
    });
    return closest.scale;
  }

  formatDateValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const rawValue = typeof value === 'string' ? value.trim() : value;
    const dateOnlyMatch = typeof rawValue === 'string'
      ? rawValue.match(/^(\d{4})-(\d{2})-(\d{2})$/)
      : null;
    const localDateTimeMatch = typeof rawValue === 'string'
      ? rawValue.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?$/)
      : null;
    let date = null;
    if (dateOnlyMatch) {
      date = new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3])
      );
    } else if (localDateTimeMatch) {
      date = new Date(
        Number(localDateTimeMatch[1]),
        Number(localDateTimeMatch[2]) - 1,
        Number(localDateTimeMatch[3]),
        Number(localDateTimeMatch[4]),
        Number(localDateTimeMatch[5]),
        Number(localDateTimeMatch[6] || 0)
      );
    } else {
      date = new Date(rawValue);
    }
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const locale = (
      localStorage.getItem('user.locale') ||
      localStorage.getItem('userLocale') ||
      i18next.language ||
      'hu'
    ).toString();
    const normalizedLocale = locale.toLowerCase().startsWith('hu') ? 'hu-HU' : locale;
    const month = new Intl.DateTimeFormat(normalizedLocale, {month: 'long'}).format(date);
    const day = date.getDate();
    const dateText = `${date.getFullYear()}. ${month} ${day}.`;
    if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
      return dateText;
    }
    const timeText = new Intl.DateTimeFormat(normalizedLocale, {
      hour: 'numeric',
      minute: '2-digit'
    }).format(date);
    return `${dateText} ${timeText}`;
  };

  customToastShow(severity, summary, detail, life) {
    window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
  }

  toastShow(severity, summary, detail, life, response) {
    if (response?.config?.__sessionExpired || response?.__sessionExpired) {
      return;
    }
    if (window.__sessionExpiredLogout === true && severity === 'error') {
      return;
    }
    if (document.getElementById('app').innerHTML.toString().includes(summary)) {

    } else {
      if (life === null || life === undefined || life < 3000 || !life) {
        life = 5000
      }
      if (response && response.data) {
        if (response.status === 400 || response.status === 422) {
          var elementInvalid = document.getElementsByClassName("p-invalid");
          var elementError = document.getElementsByClassName("p-error");
          while (elementInvalid.length > 0) {
            elementInvalid[0].classList.remove("p-invalid");
          }
          while (elementError.length > 0) {
            elementError[0].remove();
          }
          const responseData = response?.data || {};
          let summary =
            responseData?.message ||
            'A kijelölt mezők helyes kitöltése kötelező!';
          let validationData =
            responseData?.data && typeof responseData.data === 'object'
              ? responseData.data
              : responseData;
          const messages = [];
          const addMessage = (value) => {
            if (value === null || value === undefined) {
              return;
            }
            if (Array.isArray(value)) {
              value.forEach(item => addMessage(item));
              return;
            }
            if (typeof value === 'object') {
              Object.values(value).forEach(item => addMessage(item));
              return;
            }
            const text = String(value).trim();
            if (
              text &&
              text !== summary &&
              !messages.includes(text)
            ) {
              messages.push(text);
            }
          };
          Object.entries(validationData || {}).forEach(([key, value]) => {
            if (key !== 'message') {
              addMessage(value);
            }
          });
          let detail = (
            <div>
              {messages.slice(0, 3).map((message, index) => (
                <div key={index}>• {message}</div>
              ))}
              {messages.length > 3 && (
                <div>…</div>
              )}
            </div>
          );
          severity = "warn";
          // for (const key in data) {
          //   if (document.getElementById(key)) {
          //     document.getElementById(key).classList.add("p-invalid")
          //     document.getElementById(key).parentElement.parentElement
          //     .insertAdjacentHTML("afterend", "<small class=\"p-error\">" + data[key] + "</small>")
          //     document.getElementById(key).addEventListener('click', function handleClick() {
          //       document.getElementById(key).classList.remove("p-invalid");
          //       if (document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error')) {
          //         document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error').remove();
          //       }
          //     });
          //   }
          //   //detail = detail + ' ' + data[key]
          // }

          let _data = response.data.data
          if (!response.data.data) {
            _data = response.data
          }

          for (const key in _data) {
            if (document.getElementById(key)) {
              if (document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error')) {
                document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error').remove()
              }
              //document.getElementById(key).classList.add("p-invalid")
              const elements = document.querySelectorAll(`#${key}`);
              if (elements.length > 0) {
                const topElement = elements[elements.length - 1]; // Utolsó elem
                topElement.classList.add("p-invalid");
              }
              document.getElementById(key).addEventListener('click', function handleClick() {
                document.getElementById(key).classList.remove("p-invalid");
                if (document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error')) {
                  document.getElementById(key).parentElement.parentElement.parentElement.querySelector('.p-error').remove()
                }
              });
              // document.getElementById(key).parentElement.parentElement.insertAdjacentHTML("afterend",
              //   "<small class=\"p-error\">" + response.data.data[key] + "</small>")
              if (elements.length > 0) {
                const topElement = elements[elements.length - 1]; // Utolsó elem
                topElement.parentElement.parentElement.insertAdjacentHTML("afterend",
                  "<small class=\"p-error\">" + _data[key] + "</small>")
              }
            }
          }
          // if (summary === 'Nem található') {
          //   summary = 'A kijelölt mezők helyes kitöltése kötelező!'
          //   if (response.data && response.data.message) {
          //     detail = response.data.message
          //   }
          // }
          window.App.toast.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: life
          });
        } else if (response.status === 401) {
          if (localStorage.getItem('userToken') == null) {
            detail = "Hibás adatok! A bejelentkezéshez valós emailcím és jelszó megadása szükséges."
            window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
          } else {
            detail = "Lejárt munkamenet miatt a rendszer kilépett."
            severity = "warn"
            summary = "A továbblépéshez be kell jelentkezni!"
            UserLogoutService()
            window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
          }
        } else if (response.status === 404) {
          summary = "Valami nem stimmel!"
          detail = response.data.message
          if (response.data && response.data.message && response.data.message.toString().length > 200) {
            detail = process.env.REACT_APP_DEVOPS_ERROR
          }
          severity = "warn"
          window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
        } else if (response.status === 403) {
          summary = "Jogosultság nem megfelelő!"
          severity = "warn"
          detail = 'Az adatok betöltése sikertelen.'
          window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
        } else if (response.status === 409 || response.status === 500) {
          summary = "Hoppá! Hiba történt!"
          detail = process.env.REACT_APP_DEVOPS_ERROR
          window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
        } else {
          window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
        }
      } else if (detail && detail.toString().includes("401") || detail && detail.toString().includes("Authentication")) {
        detail = "Lejárt munkamenet miatt a rendszer kilépett."
        severity = "warn"
        summary = "A továbblépéshez be kell jelentkezni!"
        UserLogoutService()
        window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
      } else {
        if (severity === 'error') {
          life = 15000
          detail = process.env.REACT_APP_DEVOPS_ERROR
        }
        window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
      }
    }
  }

  urlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  render() {
    const menu = this.buildMenu();
    return (
      <Router>
        <HelperProvider>
        <div className={process.env.REACT_APP_BRAND} id="app">
          <Favicon url={require("." + process.env.REACT_APP_FAVICON_FILE)}/>
          <Toast ref={(el) => this.toast = el} position="bottom-right"/>
            {this.state.newVersionAvailable && (
          <div className="new-version-bar p-p-3 p-d-flex p-jc-center p-ai-center">
            <span className="p-mr-3">
               <i className="pi pi-info-circle p-mr-2"></i>
               Új verzió érhető el.
            </span>
            <Button 
              label="Frissítés" 
              icon="pi pi-refresh" 
              className="p-button-sm p-button-raised new-version-button"
              onClick={() => window.location.reload()} 
            />
          </div>
        )}
          {process.env.REACT_APP_ACCESS === 'disabled' ? (
            <>
              <div className="p-component p-p-3 p-text-center">
                <img src={require("." + process.env.REACT_APP_LOGO_FILE).default}
                     className="p-d-block p-my-5 p-mx-auto"/>
                <br/>
                <p className={"p-pb-0"}>
                  <strong>Karbantartás folyamatban!</strong>
                </p>
                <p className={"p-pb-3"}>
                  Pár perc türelmet kérünk és a rendszer ismét elérhető lesz.
                </p>
              </div>
            </>
          ) : (
            <>
              {localStorage.getItem('userToken') == null ? (
                <Switch>
                  <Route path="/" component={LoginPage} exact/>
                  <Route path="/login" component={LoginPage}/>
                  <Route path="/partner" component={LoginPage}/>
                  <Route path="/settings" component={LoginPage}/>
                  <Route path="/report" component={LoginPage}/>
                  <Route path="/finance" component={LoginPage}/>
                  <Route path="/project" component={LoginPage}/>
                  <Route path="/hr" component={LoginPage}/>
                  <Route path="/purchase" component={LoginPage}/>
                  <Route path="/order" component={LoginPage}/>
                  <Route path="/inventory" component={LoginPage}/>
                  <Route path="/manufacturing" component={LoginPage}/>
                  <Route path="/onboarding" component={RegistrationOnboardingPage} exact/>
                  <Route path="/registration" component={RegisterPage}/>
                  <Route path="/password-reset" component={PasswordResetPage}/>
                  <Route path="/password-set" component={PasswordSetPage}/>
                  <Route path="/new-password" component={NewPasswordPage}/>
                  <Route path="/activate/:hash" component={NewPasswordPage}/>
                </Switch>
              ) : (
                <>
                  {localStorage.getItem('scale') === '0' &&
                    <style>
                      {"\
                  html{\
                    font-size:10px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  {localStorage.getItem('scale') === '20' &&
                    <style>
                      {"\
                  html{\
                    font-size:12px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  {localStorage.getItem('scale') === '40' &&
                    <style>
                      {"\
                  html{\
                    font-size:14px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  {localStorage.getItem('scale') === '60' &&
                    <style>
                      {"\
                  html{\
                    font-size:15px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  {localStorage.getItem('scale') === '80' &&
                    <style>
                      {"\
                  html{\
                    font-size:16px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  {localStorage.getItem('scale') === '100' &&
                    <style>
                      {"\
                  html{\
                    font-size:17px !important;\
                    transition: 0.2s !important;\
                  }\
                "}
                    </style>
                  }
                  <BlockUI blocked={this.state.loading}>
                    {/*<div className={"subscriptionMessage"}>*/}
                    {/*  <div className={"p-text-center p-p-2 bg-" + "error" + "-dark text-light"}>*/}
                    {/*    Jelen időszakban szolgáltatói hibából adódóan email kézbesítési problémák léphetnek fel.
                    A proléma megoldásán a szolgáltatóval közösen dolgozunk. A számla kiállítási folyamatot a hiba nem befolyásolja.*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    {window.App.state.subscriptionMessages && window.App.state.subscriptionMessages[0] &&
                      window.App.state.subscriptionMessages.map((message, index) => {
                        if (!localStorage.getItem("subscriptionMessage_" + message.id)) {
                          return (
                            <div className={"subscriptionMessage"}
                                 onClick={() => {
                                   let confirmMessage = 'A következő bejelentkezésig ne jelenjen meg ez az üzenet?'
                                   if (message.note) {
                                     confirmMessage = message.note
                                   }
                                   if (message.closable === true) {
                                     if (window.confirm(confirmMessage)) {
                                       localStorage.setItem("subscriptionMessage_" + message.id, message.message)
                                       window.App.forceUpdate()
                                     }
                                   } else {
                                     if (message.note) {
                                       alert(confirmMessage)
                                     }
                                     if (message.type === 'subscription_expired') {
                                       window.location.replace('/#/subscriptions');
                                       window.App.forceUpdate()
                                     }
                                   }
                                 }}
                            >
                              <div className={"p-text-center p-p-2 bg-" + message.severity + "-dark text-light"}>
                                {message.message}
                                {message.closable === true &&
                                  <i className={"pi pi-times"}></i>
                                }
                              </div>
                            </div>
                          )
                        }
                      })
                    }
                    {this.state.loading === true ? (
                      <div id="header" className={"p-menubar p-component p-py-0"}
                           style={{minHeight: '52px', position: 'relative'}}>
                        <i className="pi pi-spin pi-spinner p-mt-0 p-pt-0 p-ml-4 p-d-none p-d-lg-block"
                           style={{fontSize: '1.5em', position: 'absolute', left: '0', top: '14px'}}></i>
                        <i className="pi pi-spin pi-spinner p-mt-0 p-pt-0 p-ml-4 p-d-lg-none"
                           style={{fontSize: '1.5em', position: 'absolute', left: '0', top: '17px'}}></i>
                      </div>
                    ) : (
                      <div id="header">
                        <nav>
                          <>
                            <Menubar
                              style={{minHeight: '52px'}}
                              start={
                                <>
                                  <Link to={"/"}>
                                    <img
                                      src={require("." + process.env.REACT_APP_LOGO_FILE)}/> {/* kikerült a .default a FILE után */}
                                  </Link>
                                </>
                              }
                              model={menu}
                              className={"p-py-0"}
                              end={
                                <>
                                  <div className="p-inputgroup">
                                    <SplitButton
                                      id="buttonProfile"
                                      onClick={() => {
                                        document.getElementById('buttonProfile').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                      }}
                                      icon="pi pi-user"
                                      className={"p-button-secondary p-ml-2"}
                                      model={[

                                        {
                                          separator: false,
                                          template: () => {
                                            setTimeout(() => {
                                              if (window.App && typeof window.App.checkTokenAndLogoutIfExpired === 'function') {
                                                window.App.checkTokenAndLogoutIfExpired();
                                              }
                                            }, 0);
                                            return (
                                              <div className="p-py-2 p-px-3">
                                                <span className={"p-d-block"}>
                                                  <strong>Hello {localStorage.getItem('userRealName')}!</strong>
                                                </span>
                                                <span className={"p-d-block p-mt-1"}>
                                                  {localStorage.getItem('userEmail')}
                                                </span>
                                                <span
                                                  id="sessionCountdownLabel"
                                                  className="p-d-block p-mt-1"
                                                  style={{ color: '#f97316', fontSize: '12px' }}
                                                ></span>
                                              </div>
                                            );
                                          }
                                        },
                                        {
                                          label: this.props.t('profile'),
                                          icon: 'pi pi-user',
                                          command(e) {
                                            window.App.setState({sidebarProfileUpdate: true})
                                          },
                                          className: ''
                                        },
                                        {
                                          label: this.props.t('help'),
                                          icon: 'pi pi-question-circle',
                                          command(e) {
                                            window.location.replace('/#/help');
                                            window.App.forceUpdate()
                                          },
                                          className: ''
                                        },
                                        ...(
                                          isLanguageSelectorEnabled() ? [
                                            {
                                              separator: false,
                                              template: () => (
                                                <div className="p-py-2 p-px-3" onClick={(event) => event.stopPropagation()}>
                                                  <span className={"p-d-block p-text-uppercase p-text-muted"}>
                                                    <small style={{opacity: 0.5}}>{this.props.t('language')}</small>
                                                  </span>
                                                  <Dropdown
                                                    value={window.App.state.language}
                                                    options={LANGUAGE_OPTIONS}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    className="p-mt-2"
                                                    style={{width: '100%'}}
                                                    onChange={(e) => window.App.changeAppLanguage(e.value)}
                                                  />
                                                </div>
                                              )
                                            }
                                          ] : []
                                        ),
                                        {
                                          label: this.props.t('logout'),
                                          icon: 'pi pi-power-off',
                                          command(e) {
                                            if (window.confirm(window.App.props.t('confirmLogout'))) {
                                              UserLogoutService()
                                            }
                                          },
                                          className: ''
                                        },
                                        {
                                          separator: true,
                                          template: () => <div className="p-menu-separator"></div>
                                        },
                                        ...window.App.state.subscriptionModel,
                                        {
                                          separator: false,
                                          template: () => <div className="p-py-2 p-px-3">
                                            <span className={"p-d-block p-text-uppercase p-text-muted"}>
                                              <small style={{opacity: 0.5}}>{this.props.t('fontSize')}</small>
                                            </span>
                                            <span className={"p-d-block p-mt-3"}>
                                              <div className={"p-grid"}>
                                                <div className={"p-col p-text-center p-col-align-center"}
                                                     onClick={() => {
                                                       let _scale = window.App.getScaleValue()
                                                       if(_scale >= 20) {
                                                         localStorage.setItem('scale', Number(_scale - 20))
                                                         window.App.forceUpdate()
                                                       }
                                                     }}
                                                     style={{maxWidth: '30px', cursor: 'pointer'}}>
                                                  <i className={"pi pi-minus"} style={{fontSize: '13px'}}></i>
                                                </div>
                                                <div className={"p-col p-col-align-center"}
                                                     style={{fontSize: '13px !important'}}>
                                                  <Slider value={window.App.getScaleValue()} step={20}
                                                          style={{fontSize: '13px !important'}}
                                                          onChange={(e) => {
                                                            localStorage.setItem('scale', e.value)
                                                            window.App.forceUpdate()
                                                          }}/>
                                                </div>
                                                <div className={"p-col p-text-center p-col-align-center"}
                                                     onClick={() => {
                                                       let _scale = window.App.getScaleValue()
                                                       if(_scale < 100) {
                                                         localStorage.setItem('scale', Number(_scale + 20))
                                                         window.App.forceUpdate()
                                                       }
                                                     }}
                                                     style={{maxWidth: '30px', cursor: 'pointer'}}>
                                                  <i className={"pi pi-plus"} style={{fontSize: '13px'}}></i>
                                                </div>
                                              </div>
                                            </span>
                                          </div>
                                        },
                                      ]}/>
                                  </div>
                                </>
                                // <>
                                //   <div className="p-inputgroup">
                                //     {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
                                //       <Button icon="pi pi-building"
                                //               type="button"
                                //               className={"p-button-warning"}
                                //               tooltip={"Előfizetői fiók"}
                                //               tooltipOptions={{position: 'bottom'}}
                                //               onClick={() => {
                                //                 window.location.replace('/#/subscriptions');
                                //                 window.App.forceUpdate()
                                //               }}
                                //       />
                                //     }
                                //     {localStorage.getItem('networkId') &&
                                //       <>
                                //         <Dropdown options={window.App.state.networks}
                                //                   optionLabel="name"
                                //                   optionValue="id"
                                //                   id={"networkName"}
                                //                   emptyMessage={"Még nincs céged..."}
                                //                   onMouseDown={() => {
                                //                     NetworkListService()
                                //                       .then(response => {
                                //                         if (response.data && response.data[0]) {
                                //                           window.App.setState({
                                //                             networks: response.data
                                //                           })
                                //                         }
                                //                       })
                                //                   }}
                                //                   onChange={(e) => {
                                //                     let network = window.App.state.networks.filter(item => item.id === e.value)
                                //                     localStorage.setItem('networkId', e.value)
                                //                     localStorage.setItem('networkName', network[0].name)
                                //                     localStorage.removeItem('defaultCompanyId')
                                //                     localStorage.removeItem('defaultCompanyName')
                                //                     localStorage.removeItem('defaultPaymentMethodId')
                                //                     localStorage.removeItem('defaultPaymentMethodName')
                                //                     localStorage.removeItem('defaultReceiptGroupId')
                                //                     localStorage.removeItem('defaultReceiptGroupName')
                                //                     this.networkSelect();
                                //                     window.App.forceUpdate()
                                //                     window.App.setState({
                                //                       loading: true
                                //                     })
                                //                     setTimeout(function () {
                                //                       window.location.replace('/#/');
                                //                       window.location.reload() // TODO
                                //                     }, 2500)
                                //                   }}
                                //                   value={Number(localStorage.getItem('networkId'))}
                                //         />
                                //       </>
                                //     }
                                //     {localStorage.getItem('scale') === 'small' &&
                                //       <Button icon="pi pi-search-plus"
                                //               type="button"
                                //               tooltip={"Betűméret növelése"}
                                //               tooltipOptions={{position: 'bottom'}}
                                //               onClick={() => {
                                //                 localStorage.setItem('scale', 'normal')
                                //                 document.getElementById('app').classList.add('scale-normal')
                                //                 document.getElementById('app').classList.remove('scale-small')
                                //                 window.App.forceUpdate();
                                //               }}
                                //       />
                                //     }
                                //     {localStorage.getItem('scale') === 'normal' &&
                                //       <Button icon="pi pi-search-minus"
                                //               type="button"
                                //               tooltip={"Betűméret csökkentése"}
                                //               tooltipOptions={{position: 'bottom'}}
                                //               onClick={() => {
                                //                 localStorage.setItem('scale', 'small')
                                //                 document.getElementById('app').classList.remove('scale-normal')
                                //                 document.getElementById('app').classList.add('scale-small')
                                //                 window.App.forceUpdate();
                                //               }}
                                //       />
                                //     }
                                //     {!localStorage.getItem('scale') &&
                                //       <Button icon="pi pi-search-minus"
                                //               type="button"
                                //               tooltip={"Betűméret csökkentése"}
                                //               tooltipOptions={{position: 'bottom'}}
                                //               onClick={() => {
                                //                 localStorage.setItem('scale', 'small')
                                //                 window.App.forceUpdate();
                                //               }}
                                //       />
                                //     }
                                //     {process.env.REACT_APP_BRAND === 't2d' &&
                                //       <>
                                //         <Button icon="pi pi-info-circle"
                                //                 type="button"
                                //                 tooltip={"Névjegy"}
                                //                 tooltipOptions={{position: 'bottom'}}
                                //                 className={"p-button"}
                                //                 onClick={() => {
                                //                   this.setState({
                                //                     aboutDialog: true
                                //                   })
                                //                 }}
                                //         />
                                //         <Dialog visible={this.state.aboutDialog}
                                //                 style={{width: '750px'}}
                                //                 header="A szoftver névjegye"
                                //                 modal
                                //                 onHide={() => {
                                //                   this.setState({
                                //                     aboutDialog: false
                                //                   })
                                //                 }}>
                                //           <h2 className={"p-mb-0 p-pb-0"}>Szoftver megnevezése</h2>
                                //           <strong>Trackie.io Ipar 4.0 Vállalatirányítási Rendszer</strong>
                                //           <h2 className={"p-mb-0 p-pb-0"}>Kiadja és üzemelteti</h2>
                                //           <strong>Trackie.io Kft. <br/>székhely: 1025 Budapest, Ruthén út 28.<br/>cégjegyzékszám:
                                //             01-09-377556,<br/>adószám: 28963271-2-41</strong>
                                //           <h2 className={"p-mb-0 p-pb-0"}>Licensz tulajdonos</h2>
                                //           <strong>T.2.D. Kereskedelmi és Szolgáltató Bt. (7300 Komló, Kossuth Lajos u.
                                //             3.)</strong>
                                //           <h2 className={"p-mb-0 p-pb-0"}>Licensz azonosító</h2>
                                //           <strong>TRIOT2D2023004IP</strong>
                                //         </Dialog>
                                //       </>
                                //     }
                                //     {localStorage.getItem("userName") &&
                                //       <>
                                //         <Button className={'p-button-warning p-text-uppercase'}
                                //                 icon="pi pi-user"
                                //                 tooltip={"Profil"}
                                //                 tooltipOptions={{position: 'bottom'}}
                                //                 onClick={() => {
                                //                   window.App.setState({sidebarProfileUpdate: true})
                                //                 }}/>
                                //         <Button icon="pi pi-fw pi-power-off"
                                //                 className={'p-button-danger'}
                                //                 tooltip={"Kijelentkezés"}
                                //                 tooltipOptions={{position: 'bottom'}}
                                //                 onClick={() => {
                                //                   if (window.confirm('A kilépés megerősítésére van szükség!')) {
                                //                     UserLogoutService()
                                //                   }
                                //                 }}/>
                                //       </>
                                //     }
                                //   </div>
                                // </>
                              }
                            />
                          </>
                        </nav>
                      </div>
                    )}
                    <div id="page">
                      {process.env.REACT_APP_BRAND === 'lbuild' &&
                        <Route path="/" component={FinanceDashboardPage} exact/>
                      }
                      {process.env.REACT_APP_BRAND === 'brw' &&
                        <Route path="/" component={ProjectListComponent} exact/>
                      }
                      {process.env.REACT_APP_BRAND === 'sdm' &&
                        <Route path="/" component={ProjectDashboardPage} exact/>
                      }
                      {process.env.REACT_APP_BRAND === 'trackie' &&
                        <Route path="/" component={DashboardPage} exact/>
                      }
                      {process.env.REACT_APP_BRAND === 'water2farm' &&
                        <Route path="/" component={ProjectDashboardPage} exact/>
                      }
                      {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
                        <Route path="/subscriptions" component={SubscriptionPage} exact/>
                      }
                      <Route path="/onboarding" component={RegistrationOnboardingPage} exact/>
                      <Route path="/registration/" component={RegisterPage}/>
                      {/* <Route path="/settings" component={SettingsDashboardPage}/> */}
                      {/* <Route path="/settings/:entity?/:action?/:id?" component={SettingsDashboardPage}/> */}
                      <Route path="/tracklog" component={TracklogDashboardPage}/>
                      {/* <Route path="/finance/:entity?/:action?/:id?" component={FinanceDashboardPage}/> */}
                      <Route path="/purchase" component={PurchaseDashboardPage}/>
                      <Route path="/order" component={OrderDashboardPage}/>
                      <Sidebar position="right" visible={window.App.state.sidebarProfileUpdate} closeOnEscape={true}
                               style={{width: '780px'}}
                               onHide={() => {
                                 window.App.setState({sidebarProfileUpdate: false})
                               }}>
                        <h2 className={"text-primary"}>{this.props.t('editProfile')}</h2>
                        <ProfileFormComponent/>
                      </Sidebar>
                      {/*-- routing 2.1 --*/}
                      <Route exact path="/help" component={HelperPage}/>
                      <Route exact path="/help/:helpModule" component={HelperPage}/>
                      <Route exact path="/help/:helpModule/:helpScreen" component={HelperPage}/>
                      <Route exact path="/help/:helpModule/:helpScreen/:helpSection" component={HelperPage}/>
                      <Route path="/partner/:action?/:id?" component={PartnerPage}/>
                      <Route path="/:module(crm)/:entity?/:action?/:id?" component={CrmPage}/>
                      <Route path="/:module(project)/:entity?/:action?/:id?" component={ProjectPage}/>
                      <Route path="/:module(production)/:entity?/:action?/:id?" component={ProductionPage}/>
                      <Route path="/:module(finance)/:entity?/:action?/:id?" component={FinancePage}/>
                      <Route path="/:module(hr)/:entity?/:action?/:id?" component={HrPage}/>
                      <Route path="/:module(docs)/:entity?/:action?/:id?" component={DocsPage}/>
                      <Route path="/:module(inventory)/:entity?/:action?/:id?" component={InventoryPage}/>
                      <Route path="/:module(procurement)/:entity?/:action?/:id?" component={ProcurementPage}/>
                      <Route path="/:module(settings)/:entity?/:action?/:id?" component={SettingsPage}/>
                      <Route path="/:module(recruitment)/:entity?/:action?/:id?" component={RecruitmentPage}/>
                      <Sidebar position="left" visible={window.App.state.sidebarSystemSettings} closeOnEscape={true} style={{width: '780px'}}
                        onHide={() => {
                          window.App.setState({sidebarSystemSettings: false});
                        }}
                      >
                        <h2 className={"text-primary"}>{this.props.t('App\\Settings\\System-settings')}</h2>
                        <Panel>
                          <SystemSettingsFormComponent />
                        </Panel>
                      </Sidebar>
                      {/* <Route path="/settings" component={SettingsDashboardPage}/> */}
                      <Route path="/:module(tmp)/:entity?/:action?/:id?" component={_TMPPage}/>
                      <HelperComponent global />
                    </div>
                  </BlockUI>
                </>
              )}
            </>
          )}
        </div>
        </HelperProvider>
      </Router>
    );
  }
}

export default withTranslation('common')(App);
